/* Página da Everyday BB (porte do GemPages): galeria, variantes, compra e carrosséis. Sem dependência do app. */
(function () {
  if (window.__nvgp) return; window.__nvgp = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function dinheiro(c) {
    var f = (window.Shopify && Shopify.money_format) || '${{amount}}';
    var v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }
  /* carrossel por rolagem: bolinhas + setas + índice ativo */
  function carrossel(track, dots, prev, next, aoMudar) {
    if (!track) return null;
    var itens = Array.prototype.slice.call(track.children), atual = 0;
    function larg() { return itens[1] ? itens[1].offsetLeft - itens[0].offsetLeft : track.clientWidth; }
    function ir(i, suave) { i = Math.max(0, Math.min(itens.length - 1, i)); var longe = Math.abs(i - atual) > 1; /* pulo longo é instantâneo: o WebKit interrompe o smooth no meio */ track.scrollTo({ left: itens[i].offsetLeft - track.offsetLeft, behavior: (suave === false || longe) ? 'auto' : 'smooth' }); }
    function marca(i) {
      atual = i;
      if (dots) $$('button', dots).forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= itens.length - 1;
      if (aoMudar) aoMudar(i);
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = Math.round(track.scrollLeft / larg()); if (i !== atual) marca(i); }, 80); }, { passive: true });
    if (dots) $$('button', dots).forEach(function (b, k) { b.addEventListener('click', function () { ir(k); }); });
    if (prev) prev.addEventListener('click', function () { ir(atual - 1); });
    if (next) next.addEventListener('click', function () { ir(atual + 1); });
    marca(0);
    return { ir: ir, get: function () { return atual; } };
  }

  document.addEventListener('DOMContentLoaded', function () {
    /* ---------- compra ---------- */
    var sec = $('[data-nvgp-buy]');
    if (sec) {
      var variantes = []; try { variantes = JSON.parse($('[data-gp-variants]', sec).textContent); } catch (e) {}
      var form = $('[data-nvgp-form]', sec), btn = $('.nvgp-atc', sec);
      var slides = $$('.nvgp-gal__slide', sec), thumbs = $$('.nvgp-thumbs__item', sec);
      var gal = carrossel($('[data-gal-track]', sec), null, $('[data-gal-prev]', sec), $('[data-gal-next]', sec), function (i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var th = thumbs[i], tr = $('[data-th-track]', sec);
        if (th && tr) { var l = th.offsetLeft - tr.offsetLeft; if (l < tr.scrollLeft || l + th.offsetWidth > tr.scrollLeft + tr.clientWidth) tr.scrollTo({ left: l, behavior: 'smooth' }); }
      });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { gal.ir(k); }); });
      var thTrack = $('[data-th-track]', sec);
      $('[data-th-prev]', sec).addEventListener('click', function () { thTrack.scrollBy({ left: -thTrack.clientWidth, behavior: 'smooth' }); });
      $('[data-th-next]', sec).addEventListener('click', function () { thTrack.scrollBy({ left: thTrack.clientWidth, behavior: 'smooth' }); });

      var opts = $$('.nvgp-opt', sec);
      function escolhidos() { return opts.map(function (o) { var on = $('.is-on', o); return on ? on.getAttribute('data-val') : null; }); }
      function acha(sel) { return variantes.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0]; }
      function aplica() {
        var sel = escolhidos(), v = acha(sel);
        opts.forEach(function (o, k) { var l = $('[data-opt-label]', o); if (l) l.textContent = sel[k] || ''; });
        /* cor sem variante disponível para o estilo escolhido fica apagada */
        opts.forEach(function (o, k) {
          $$('[data-val]', o).forEach(function (b) {
            var s2 = sel.slice(); s2[k] = b.getAttribute('data-val'); var vv = acha(s2);
            b.classList.toggle('is-off', !vv || !vv.available);
          });
        });
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; } return; }
        $('input[name="id"]', form).value = v.id;
        $('[data-gp-price]', sec).textContent = dinheiro(v.price);
        var cp = $('[data-gp-compare]', sec), sv = $('[data-gp-save]', sec), tem = v.compare_at_price > v.price;
        cp.hidden = !tem; sv.hidden = !tem;
        if (tem) { cp.textContent = dinheiro(v.compare_at_price); $('[data-gp-save-pct]', sec).textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price); }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
        if (v.featured_media) { var i = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id)); if (i >= 0) gal.ir(i); }
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
      }
      opts.forEach(function (o) {
        $$('[data-val]', o).forEach(function (b) { b.addEventListener('click', function () { $$('[data-val]', o).forEach(function (x) { x.classList.remove('is-on'); }); b.classList.add('is-on'); aplica(); }); });
      });
      aplica();
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (btn) btn.removeAttribute('aria-busy');
            if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); return; }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [res.j] } }));
            // gaveta = UpCart; sem ele, página do carrinho (mesmo caminho do nv.js)
            if (window.upcartOpenCart) { window.upcartOpenCart(); return; }
            if (!document.getElementById('upCart')) { location.href = '/cart'; }
          })
          .catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
      });
      carrossel($('[data-quote-track]', sec), $('[data-quote-dots]', sec));
    }
    /* ---------- "happy customers": play ao clicar, um por vez; arrastar com o mouse ---------- */
    $$('[data-happy-track]').forEach(function (tr) {
      var itens = $$('[data-happy-item]', tr);
      itens.forEach(function (it) {
        var v = $('video', it);
        it.addEventListener('click', function () {
          if (tr.__moveu) return;
          if (v.paused) { itens.forEach(function (o) { if (o !== it) { $('video', o).pause(); o.classList.remove('is-playing'); } }); v.muted = false; v.play().catch(function () {}); it.classList.add('is-playing'); }
          else { v.pause(); it.classList.remove('is-playing'); }
        });
      });
      var x0 = 0, s0 = 0, down = false;
      tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; tr.__moveu = false; x0 = e.clientX; s0 = tr.scrollLeft; tr.classList.add('is-drag'); });
      tr.addEventListener('pointermove', function (e) { if (!down) return; var d = e.clientX - x0; if (Math.abs(d) > 4) tr.__moveu = true; tr.scrollLeft = s0 - d; });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { tr.addEventListener(ev, function () { down = false; tr.classList.remove('is-drag'); setTimeout(function () { tr.__moveu = false; }, 50); }); });
    });
    /* ---------- vídeos ---------- */
    var vt = $('[data-vids-track]');
    if (vt) {
      carrossel(vt, $('[data-vids-dots]'));
      $$('video', vt).forEach(function (v) { v.play && v.play().catch(function () {}); });
    }
  });
})();
